import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { CustomerListResponseOutputItemsItem } from '@/api/generated';
import { CustomersTableRow } from '@/components/blocks/customers/customers-table-row';
import { TableBody, TableCell, TableRow } from '@/components/ui/table';
import { getCompletionRate, getTotalCount } from '@/lib/label-counts';

const HIGH_PENDING_THRESHOLD = 500;

interface CustomersTableBodyProps {
  filteredCustomers: Array<CustomerListResponseOutputItemsItem>;
  customers: Array<CustomerListResponseOutputItemsItem>;
  handleSelectCustomer: (customerId: number) => Promise<void>;
}

export const CustomersTableBody: FC<CustomersTableBodyProps> = ({
  filteredCustomers,
  customers,
  handleSelectCustomer,
}: CustomersTableBodyProps) => {
  const { t } = useTranslation();

  return (
    <TableBody className='divide-outline-variant divide-y [&_tr:last-child]:border-primary'>
      {filteredCustomers.length === 0 ? (
        <TableRow className='hover:bg-transparent'>
          <TableCell
            colSpan={7}
            className='text-muted-foreground bg-white py-12 text-center text-sm whitespace-normal'>
            {customers.length === 0
              ? t('common.empty')
              : t('customers.noMatches')}
          </TableCell>
        </TableRow>
      ) : (
        filteredCustomers.map((customer) => {
          const pendingAnnotations = customer.counts.unannotated;
          const hasHighPending = pendingAnnotations > HIGH_PENDING_THRESHOLD;
          const completionRate = getCompletionRate(customer.counts);
          const totalItems = getTotalCount(customer.counts);

          return (
            <CustomersTableRow
              key={customer.id}
              customer={customer}
              completionRate={completionRate}
              hasHighPending={hasHighPending}
              pendingAnnotations={pendingAnnotations}
              totalItems={totalItems}
              onSelectCustomer={handleSelectCustomer}
            />
          );
        })
      )}
    </TableBody>
  );
};
